export const toggleAdminSelectionList = (items = [], idField, targetId) => {
    return items.map((item) => {
        const currentId = item?.[idField];
        if (currentId !== targetId) {
            return item;
        }
        return {
            ...item,
            checked: !item?.checked,
        };
    });
};

export const deriveSiteAdminSelection = (items = []) => {
    return items.filter((item) => item?.checked);
};

export const findAdminMapEntry = (collection, id) => {
    if (!collection || !id) {
        return null;
    }

    if (Array.isArray(collection)) {
        return collection.find((item) =>
            item?.id === id ||
            item?.user_id === id ||
            item?.organization_group_id === id ||
            item?._id === id
        ) || null;
    }

    return collection?.[id] || null;
};

const buildUserAdminEntry = (id, userMap = {}) => {
    const user = findAdminMapEntry(userMap, id);
    return {
        id,
        email: user?.email || user?.qid || '',
    };
};

const buildGroupAdminEntry = (id, groupMap = {}) => {
    const group = findAdminMapEntry(groupMap, id);
    return {
        id,
        name: group?.name || '',
    };
};

export const buildStandaloneAdminPayload = (admins, rowData, userMap, groupMap) => {
    const selectedUsers = admins?.users || [];
    const selectedGroups = admins?.groups || [];
    const currentUsers = rowData?.admin?.users || [];
    const currentGroups = rowData?.admin?.groups || [];

    return {
        admin: {
            add: {
                users: selectedUsers
                    .filter((id) => !currentUsers.includes(id))
                    .map((id) => buildUserAdminEntry(id, userMap)),
                groups: selectedGroups
                    .filter((id) => !currentGroups.includes(id))
                    .map((id) => buildGroupAdminEntry(id, groupMap)),
            },
            remove: {
                users: currentUsers
                    .filter((id) => !selectedUsers.includes(id))
                    .map((id) => buildUserAdminEntry(id, userMap)),
                groups: currentGroups
                    .filter((id) => !selectedGroups.includes(id))
                    .map((id) => buildGroupAdminEntry(id, groupMap)),
            },
        },
    };
};
